import { MakePaths } from "common/router/types";
import { MakeRoutesOpts } from "common/router/utils/routes";
import { makeUrls } from "common/router/utils/urls";

import { makeClientRoutes } from "client/routes/types";
import { ProductSearchSearch } from "client/products/types";

const paths = {
  detail: "/:slug",
};

type ProductCollectionDetailParams = {
  slug: string;
};

type ProductCollectionPathDefinitions = {
  detail: { Params: ProductCollectionDetailParams; Search: ProductSearchSearch };
};

export type ProductCollectionPaths = MakePaths<ProductCollectionPathDefinitions>;

export const useProductCollectionRoutes = (opts: MakeRoutesOpts) => {
  return makeClientRoutes(opts, [
    {
      path: paths.detail,
      element: () => import("../components/ProductCollectionPage"),
      // pageName drives analytics; "brand" matches the public /brands URL, not the module name.
      pageName: "brand",
    },
  ]);
};

export const makeProductCollectionUrls = (base: string) => {
  return makeUrls<ProductCollectionPathDefinitions>(base, {
    detail: { path: paths.detail, to: ({ slug }) => `/${slug}` },
  });
};
